
export function LogoMarca(props: {height?: number, width?: number}) {
    return <img src={'logo-odontus.png'} height={props.height || 50} width={props.width || 125} style={{alignSelf:"center"}} />
}